import React, { useState } from 'react';
import { Bell, Send } from 'lucide-react';
import { useNotifications } from '../../hooks/useNotifications';

export default function NotificationsPanel() {
  const { preferences, loading, savePreferences, sendTestEmail } = useNotifications();
  const [emailNotifications, setEmailNotifications] = useState(preferences.emailNotifications);
  const [securityAlerts, setSecurityAlerts] = useState(preferences.securityAlerts);

  const handleSavePreferences = async () => {
    await savePreferences({
      emailNotifications,
      securityAlerts
    });
  };

  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-lg font-medium text-gray-900">Notification Preferences</h2>
        <p className="mt-1 text-sm text-gray-500">
          Choose how you want to receive notifications and alerts.
        </p>
      </div>

      <div className="border-t border-gray-200 pt-6">
        <div className="bg-white shadow-sm rounded-lg border border-gray-200">
          <div className="px-4 py-5 sm:p-6">
            <div className="space-y-6">
              <div className="flex items-start">
                <div className="flex items-center h-5">
                  <input
                    id="email-notifications"
                    type="checkbox"
                    checked={emailNotifications}
                    onChange={(e) => setEmailNotifications(e.target.checked)}
                    className="h-4 w-4 text-orange-600 focus:ring-orange-500 border-gray-300 rounded"
                  />
                </div>
                <div className="ml-3">
                  <label htmlFor="email-notifications" className="font-medium text-gray-700">
                    Email Notifications
                  </label>
                  <p className="text-sm text-gray-500">
                    Receive email notifications about WAF rule updates and changes.
                  </p>
                </div>
              </div>

              <div className="flex items-start">
                <div className="flex items-center h-5">
                  <input
                    id="security-alerts"
                    type="checkbox"
                    checked={securityAlerts}
                    onChange={(e) => setSecurityAlerts(e.target.checked)}
                    className="h-4 w-4 text-orange-600 focus:ring-orange-500 border-gray-300 rounded"
                  />
                </div>
                <div className="ml-3">
                  <label htmlFor="security-alerts" className="font-medium text-gray-700">
                    Security Alerts
                  </label>
                  <p className="text-sm text-gray-500">
                    Get immediate alerts about security-related events and potential threats.
                  </p>
                </div>
              </div>

              <div className="flex justify-end space-x-3">
                <button
                  onClick={sendTestEmail}
                  disabled={loading}
                  className="inline-flex items-center px-4 py-2 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50"
                >
                  <Send className="h-5 w-5 mr-2" />
                  Send Test Email
                </button>
                <button
                  onClick={handleSavePreferences}
                  disabled={loading}
                  className="inline-flex items-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-orange-600 hover:bg-orange-700"
                >
                  {loading ? (
                    <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-white" />
                  ) : (
                    <>
                      <Bell className="h-5 w-5 mr-2" />
                      Save Preferences
                    </>
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}